// import { SCHEMA } from '@vedalib/editor/lib/brand'
// import React, { useMemo } from 'react'
import { SCHEMA } from '@vedalib/editor/lib/brand'
import { useCallback, useMemo } from 'react'

import Padding from 'components/Editor/Toolbar/Padding'
import { LayoutScroll } from 'components/LayoutPage'
import { Typography } from 'components/uiKit/Typography'
import {
  BrandButtonFont,
  BrandFormFontBase,
  BrandGoBack,
  BrandRichTextFontForms,
  BrandRichTextTypography,
} from 'services/Branding/components'
import { FONT_FIELDS } from 'services/Branding/fieldConfigs'
import { genSchema } from 'services/Branding/genSchema'
import { useElementFontCss, useElementFontValues, useUpdateSchema } from 'services/Branding/hooks'
import { BrandFormEnum } from 'services/Branding/types'
import { t } from 'services/Translation'

import type { TestKeyboardInputFormBrandType } from './testKeyboardInputTypes'

const FONT_FORM_SCHEMA = genSchema(SCHEMA.testKeyboardInput.font, {
  ...FONT_FIELDS,
  placeholder: FONT_FIELDS.base,
})

const TypographyPlaceholder: TestKeyboardInputFormBrandType = ({ setForm, device, subConfigs }) => {
  const fontPath = useMemo(() => ['font', device], [device])
  const fontSchema = useUpdateSchema(fontPath, subConfigs, FONT_FORM_SCHEMA)

  const handleSetTypography = useCallback(() => setForm?.(BrandFormEnum.TYPOGRAPHY), [setForm])

  return (
    <BrandFormFontBase font={fontSchema.placeholder}>
      <BrandGoBack onClick={handleSetTypography}>
        <Typography weight='medium'>{t('elements.testKeyboardInput.tags.placeholder')}</Typography>
      </BrandGoBack>
      <Typography styleType='hint'>{t('page.brand.fonts.inheritHint')}</Typography>
    </BrandFormFontBase>
  )
}

const TestKeyboardInputTypography: TestKeyboardInputFormBrandType = ({
  element,
  device,
  edited,
  setForm,
}) => {
  const values = useElementFontValues('testKeyboardInput', device, element?.font)
  const styles = useElementFontCss('testKeyboardInput', device, element?.font)

  const goBack = useCallback(() => setForm?.(BrandFormEnum.STYLE), [setForm])

  return (
    <LayoutScroll sizeAutoCapable>
      <Padding bottom bottomSpace gap sides>
        <BrandGoBack onClick={goBack}>
          <Typography weight='medium'>{t('page.brand.tab.typography')}</Typography>
        </BrandGoBack>
        <BrandRichTextTypography
          edited={edited.font}
          setActiveFont={setForm}
          styles={styles}
          values={values}
        />
        <BrandButtonFont
          edited={edited.font?.placeholder}
          font='placeholder'
          onClick={setForm}
          styles={styles.placeholder}
          values={values.placeholder}
        >
          {t('elements.testKeyboardInput.tags.placeholder')}
        </BrandButtonFont>
      </Padding>
    </LayoutScroll>
  )
}

const FONTS_FORM_MAP = {
  [BrandFormEnum.TYPOGRAPHY]: TestKeyboardInputTypography,
  placeholder: TypographyPlaceholder,
  ...BrandRichTextFontForms,
}

export default FONTS_FORM_MAP
